export type PostalCodePolygonResponse = {
	type: "Feature";
	id: string;
	geometry: {
		type: "Multipolygon";
		coordinates: [][][][];
	};
	properties: {
		postalCode: string;
		postalName: string;
		municipality: string;
	};
};

export async function fetchPostalCodePolygonData(
	proxyUrl: string | undefined,
	postalCode: string | undefined,
): Promise<PostalCodePolygonResponse | undefined> {
	try {
		if (!proxyUrl) throw new Error("Proxy URL not found");
		const url = new URL(`${proxyUrl}/api/geoSpatial/${postalCode}`);

		const response = await fetch(url);
		if (!response.ok) throw new Error(`Server responded with status ${response.status}`);

		const postalCodePolygonReponse = (await response.json()) as PostalCodePolygonResponse;
		return postalCodePolygonReponse;
	} catch (err) {
		console.error("Failed to fetch postal code polygon data", err);
		return undefined;
	}
}
